import React, { useState, useEffect, useRef } from 'react'
import classnames from 'classnames'
import { useCountUp } from 'react-countup'

import { Text } from '@krea/common/shared-components'

import styles from './ProgressBar.module.scss'

const ProgressBar = ({ isCompleted }) => {
	const minValue = 0
	const maxValue = 100
	const maxTime = 30 //seconds
	const maxCompleted = 98 //%

	const countUpRef = useRef(null)

	const [value, setValue] = useState(minValue)

	const calcTime = (maxTime * maxValue) / maxCompleted
	const step = maxValue / calcTime

	useEffect(() => {
		let interval

		if (isCompleted) {
			setValue(maxValue)
			clearInterval(interval)
		} else {
			interval = setInterval(() => {
				setValue((prevValue) => (Math.round(prevValue) < Math.round(step * maxTime) ? prevValue + step : prevValue))
			}, 1 * 1000)
		}

		return () => clearInterval(interval)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isCompleted])

	const { update } = useCountUp({
		ref: countUpRef,
		start: 0,
		delay: 1000,
		duration: 1,
		suffix: '%'
	})

	useEffect(() => {
		update(value)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value])

	return (
		<div className="d-flex align-items-center">
			<div className="w-100 rounded overflow-hidden position-relative">
				<div className={classnames(styles.root, 'w-100 rounded')}>
					<div
						className={classnames(styles.progress, 'position-absolute rounded bg-primary h-100')}
						style={{ width: `${value}%` }}
					/>
				</div>
			</div>
			<Text
				size="sm"
				className={classnames(styles.counter, 'flex-shrink-0 font-weight-bold text-gray-dark text-right')}
			>
				<span ref={countUpRef} />
			</Text>
		</div>
	)
}

export default ProgressBar
